import React, { useRef, useEffect } from 'react'
import { useLocation } from 'react-router'

export default function Cursor() {

    const cursor = useRef(null)
    
    let path = useLocation().pathname
    useEffect(() => {
      document.addEventListener('mousemove',(e)=>{
        cursor.current.style.left = e.clientX + 'px'
        cursor.current.style.top = e.clientY + 'px'
    })
      const works = document.querySelectorAll('.worki')
      function inWork() {
        cursor.current.style.background = '#fff'
        cursor.current.style.borderColor = 'transparent'
        cursor.current.style.width = '50px'
        cursor.current.style.height = '50px'
        cursor.current.innerText = "View"
        cursor.current.style.color = "#181818"
        cursor.current.style.mixBlendMode = "normal"
        cursor.current.style.transition = ".1s"
      }
      function normal() {
        cursor.current.style.background = 'transparent'
        cursor.current.style.borderColor = '#fff'
        cursor.current.style.width = '12px'
        cursor.current.style.height = '12px'
        cursor.current.innerText = ""
        cursor.current.innerHTML = `<div></div>`
        cursor.current.style.mixBlendMode = "difference"
        cursor.current.style.transition = ""
      }
      works.forEach(work=>{
        work.addEventListener('mousemove',(e)=>{
          inWork()
        })
        work.addEventListener('mouseout',(e)=>{
          normal()
        })
      })
      
      if(path != '/work'){ normal()  }
      
      
    })
    

  return (
    <div className='cursor' ref={cursor}><div></div></div>
  )
}
